const initState = {
    equipmentOverviewInfo: {},
    equipmentStatusOverview: {},
    equipmentStatusNotifications: {},
};

const SET_EQUIPMENT_OVERVIEW = 'SET_EQUIPMENT_OVERVIEW';
const SET_EQUIPMENT_STATUS_OVERVIEW = 'SET_EQUIPMENT_STATUS_OVERVIEW';
const SET_EQUIPMENT_STATUS_NOTIFICATIONS = 'SET_EQUIPMENT_STATUS_NOTIFICATIONS';

export const setEquimentOverviewInfo = (data) => ({ type: SET_EQUIPMENT_OVERVIEW, payload: data });
export const setEquipmentStatusOverview = (data) => ({
    type: SET_EQUIPMENT_STATUS_OVERVIEW,
    payload: data,
});
export const setEquipmentStatusNotifications = (data) => ({
    type: SET_EQUIPMENT_STATUS_NOTIFICATIONS,
    payload: data,
});

export default (state = initState, action) => {
    switch (action.type) {
        case SET_EQUIPMENT_OVERVIEW:
            return { ...state, equipmentOverviewInfo: action.payload };
        case SET_EQUIPMENT_STATUS_OVERVIEW:
            return { ...state, equipmentStatusOverview: action.payload };
        case SET_EQUIPMENT_STATUS_NOTIFICATIONS:
            return { ...state, equipmentStatusNotifications: action.payload };
        default:
            return state;
    }
};
